
import moment from 'moment';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

import { OrderMethods } from '@/enums';
import BasketModule from '@/store/modules/basket';
import { hideCMSContent, parseDate } from '@/utils/global.util';

@Component({
  components: {
  }
})
export default class SingleOrder extends Vue {
  @Prop({ type: String, default: '' }) arrivalStatus: string;
  @Prop({ type: Number, default: null }) customerHandoffCharge: number;
  @Prop({ type: Object, default: null }) deliveryAddress: DeliveryAddress;
  @Prop({ type: String, default: '' }) deliveryMode: string;
  @Prop({ type: Number, default: null }) discount: number;
  @Prop({ type: Array, default: () => [] }) fees: FeeModel[];
  @Prop({ type: String, default: '' }) id: string;
  @Prop({ type: String, default: '' }) instructions: string;
  @Prop({ type: String, default: '' }) oloId: string;
  @Prop({ type: String, default: '' }) orderRef: string;
  @Prop({ type: Array, default: () => [] }) products: OrderProductModel[];
  @Prop({ type: String, default: '' }) readyTime: string;
  @Prop({ type: Number, default: null }) salesTax: number;
  @Prop({ type: Number, default: null }) subTotal: number;
  @Prop({ type: String, default: '' }) status: string;
  @Prop({ type: Array, default: () => [] }) taxes: TaxModel[];
  @Prop({ type: String, default: '' }) timeMode: string;
  @Prop({ type: String, default: '' }) timePlaced: string;
  @Prop({ type: Number, default: null }) tip: number;
  @Prop({ type: Number, default: null }) total: number;
  @Prop({ type: Number, default: null }) totalFees: number;
  @Prop({ type: String, default: '' }) vendorName: string;

  @Action fetchRestaurant: ({ restaurantId }: { restaurantId: number }) => void;

  async handleReOrder(oloId, orderRef, deliveryMode) {
    const loader = this.$loading.show();
    try {
      this.$emit('handle-reorder');
      hideCMSContent();
      const restaurant = await BasketModule.createBasketFromPreviousOrder({ orderRef, oloId });
      if (deliveryMode === 'curbside') {
        await BasketModule.setHandoffMethod({ method: OrderMethods.CURBSIDE });
      }
      this.$router.push({
        name: 'OrderSummary',
        params: {
          location: restaurant.slug,
        }
      });
    } catch (err) {
      this.$log.error(err);
      this.$toasted.error(err.data);
    } finally {
      loader.hide();
    }
  }

  get parsedTimePlaced() {
    return moment(parseDate(this.timePlaced)).format('MM/DD/YY');
  }

  get itemCountText() {
    if (this.products.length === 1) {
      return '1 item';
    }
    return `${this.products.length} items`;
  }

  @Emit('previewOrder')
  previewOrder() {
    return { ...this.$props, ...this.$attrs };
  }
}
